<template>
  <card
    title="הזמנות שצריך לסגור"
    :linkTo="`/orders?orderStatuses=${checkedInId}`"
    actionButton="לכל ההזמנות שצריך לסגור"
    :number="number"
    :loading="loading"
    :error="error"
  />
</template>

<script>
import { format } from 'date-fns';
import { getApi } from '@/api';
import Card from "./Card.vue";

export default {
  data() {
    return {
      number: 0,
      loading: false,
      error: false
    };
  },

  computed: {
    checkedInId() {
      let checkedIn = Object.values(this.$store.state.entities.orderStatuses).find(item => {
        return item.key === 'CHECKED_IN';
      })
      return checkedIn ? checkedIn._id : null;
    }
  },

  methods: {
    format,
    fetchData() {
      this.loading = true;
      getApi()
        .then(api => {
          let params = {
            orderStatuses: this.checkedInId
          };
          return api.get('/orders', { params })
        })
        .then(({ data }) => {
          this.number = data.totalResults;
        })
        .catch(err => {
          console.log(err);
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        })
    }
  },

  props: [],

  mounted() {
    this.fetchData();
  },

  components: {
    Card
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
